import React, { useState, useEffect } from 'react';
// import ForumDiscussion from './Components/ForumDiscussion';
import TbesCompont from './Components/TbesCompont';
import MapComponent from './Components/MapComponent';
import decodeHtml from '../../Uitiles/decodeHtml';
import { oneKlicks } from '../../SDK/oneclick';
import Feedbackcount from '../../Uitiles/Feedbackcount';
import DoctorSpecialities from '../Frontend/Home/Components/DoctorSpecialities';
import FeedbackPopup from './Components/FeedbackPopup';
import { extractAddressForMap } from '../../utils/locationUtils';
import BookingPopup from './Components/BookingPopup';
import formatDoctorName from '../../Uitiles/FormatName';
import { toast } from "react-toastify";
import GoogleMapsLink from '../../components/GoogleMapsLink';
import { addToWishlist } from '../../services/apiService';

const Doctorpage = ({ data, loadtype }) => {
    console.log('ldoctor data oadtype :', loadtype);
    const [showcomponents, setShowComponents] = useState("Doctor Details");
    console.log('doctor data :', data);
    const [doctorDetails, setDoctorDetails] = useState(null);
    const [feedback, setFeedback] = useState([]);

    // Calculate average rating from feedback
    const calculateAverageRating = () => {
        if (!feedback || feedback.length === 0) return 0;
        const totalRating = feedback.reduce((sum, item) => sum + parseInt(item.rating), 0);
        return (totalRating / feedback.length).toFixed(1);
    };


    const toggleAdvancedSearch = (data) => {
        console.log('toggleAdvancedSearch data :', data);
        // update the url presint url ? tab=data
        window.history.pushState({}, '', `?tab=${data}`);
        setShowComponents(data);
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab');
        if (tab) {
            setShowComponents(tab);
        }

        // Check for booking success
        const bookingSuccess = urlParams.get('booking');
        if (bookingSuccess === 'success') {
            toast.success('Booking successful');
            window.history.replaceState({}, '', window.location.pathname + (tab ? `?tab=${tab}` : ''));
        }
    }, []);



    useEffect(() => {
        console.log('doctor data :', data);
        getDoctorDetails();
        fetchFeedback();
    }, [data, loadtype]);


    const getDoctorDetails = async () => {
        const tableSchema = '';
        const tableName = 'users';
        const conditions = {
            id: data.id
        };
        const orderBy = '';
        const search = '';
        const pagination = '';
        const margedata = [
            {
                target_table: loadtype === 'hospitals' ? 'hospitals_default_location' : 'doctor_default_location',
                target_column: 'user_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospitals_default_location' : 'doctor_default_location'
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospital_specialities' : 'doctor_specialities',
                target_column: loadtype === 'hospitals' ? 'hospital_id' : 'doctor_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospital_specialities' : 'doctor_specialities',
                margedata: [
                    {
                        target_table: 'specialities',
                        target_column: 'id',
                        target_value: 'speciality_id',
                        target_label: 'specialities'
                    },
                    {
                        target_table: 'services',
                        target_column: 'id',
                        target_value: 'service_id',
                        target_label: 'services'
                    }
                ]
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospitals_experience_education' : 'doctor_experience_education',
                target_column: 'user_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospitals_experience_education' : 'doctor_experience_education'
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospital_appointment_settings' : 'appointment_settings',
                target_column: 'doctor_id',
                target_value: 'id',
                target_label: 'appointment_settings'  //doctor_awards_downloads
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospitals_awards_downloads' : 'doctor_awards_downloads',
                target_column: 'user_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospitals_awards_downloads' : 'doctor_awards_downloads'  //doctor_registrations
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospitals_registrations' : 'doctor_registrations',
                target_column: 'user_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospitals_registrations' : 'doctor_registrations' //doctor_gallery
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospitals_gallery' : 'doctor_gallery',
                target_column: 'user_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospitals_gallery' : 'doctor_gallery'  //doctor_social_profiles
            },
            {
                target_table: loadtype === 'hospitals' ? 'hospital_social_profiles' : 'doctor_social_profiles',
                target_column: 'user_id',
                target_value: 'id',
                target_label: loadtype === 'hospitals' ? 'hospital_social_profiles' : 'doctor_social_profiles'
            }

        ];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log('doctor data get show details:', response.data[0]);
        if (response) {
            setDoctorDetails(response.data[0]);
        } else {
            console.log('No doctor found');
        }
    };

    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
    const [isBookingOpen, setIsBookingOpen] = useState(false);

    const fetchFeedback = async () => {
        const tableSchema = '';
        const tableName = 'feedbacks';
        const conditions = {
            doctor_id: data.id
        };
        const orderBy = 'id DESC';
        const search = '';
        const pagination = '';
        const margedata = '';
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        console.log('Feedback response :', response);
        if (response) {
            console.log('Feedback response :', response.data);
            setFeedback(response.data);
        } else {
            setFeedback([]);
            console.log('No feedback found');
        }
    };


    return (

        <div className="container">
            <div className="row">
                <div id="dc-twocolumns" className="dc-twocolumns dc-haslayout">
                    <div className="col-12 col-lg-12 col-xl-9 float-left">
                        <div className="dc-docsingle-header" style={{
                            display: 'flex',
                            borderRadius: 5,
                            boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
                            padding: '32px 32px 32px 24px',
                            marginBottom: 32,
                            gap: 32,
                        }}>
                            <figure className="dc-docsingleimg1" style={{ margin: 0, minWidth: 140, padding: 10 }}>
                                <img
                                    className="dc-ava-detail1"
                                    src={
                                        loadtype === 'hospitals'
                                            ? (data.profile_photo_url
                                                ? (process.env.REACT_APP_API_BASE_URL + data.profile_photo_url)
                                                : "//css.meddylist.com//wp-content/uploads/2019/11/sidebar01.jpg")
                                            : (data.profile_photo_url
                                                ? (process.env.REACT_APP_API_BASE_URL + data.profile_photo_url)
                                                : "https://apis.oneklicks.com/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png")
                                    }
                                    alt={data.display_name}
                                    style={{
                                        width: 140,
                                        height: 140,
                                        borderRadius: '5px',
                                        objectFit: 'cover',
                                        border: '4px solid #fff',
                                        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                        background: '#f4f8fb'
                                    }}
                                />
                            </figure>
                            <div className="dc-docsingle-content" style={{ flex: 1 }}>
                                <div className="dc-title" style={{ marginBottom: 12 }}>
                                    <div className="dc-doc-specilities-tag" style={{ marginBottom: 8 }}>
                                        <DoctorSpecialities doctorId={data.id} data={doctorDetails || []} type="list" />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        {/* title single line */}
                                        <h2 style={{
                                            margin: 0,
                                            fontWeight: 700,
                                            fontSize: 28,
                                            color: '#1a237e',
                                            letterSpacing: '-0.5px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'left',
                                            gap: 10
                                        }}>
                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                {decodeHtml(formatDoctorName(data.display_name, loadtype))}
                                            </span>
                                            {doctorDetails?.is_verified && (
                                                <>
                                                    <span title="Medical Registration Verified" style={{ color: '#4caf50', fontSize: 22 }}>
                                                        <i className="icon-sheild dc-awardtooltip dc-tipso tipso_style" />
                                                    </span>
                                                    <span title="Verified user" style={{ color: '#2196f3', fontSize: 22 }}>
                                                        <i className="far fa-check-circle dc-awardtooltip dc-tipso tipso_style" />
                                                    </span>
                                                </>
                                            )}
                                        </h2>
                                    </div>
                                    <ul className="dc-docinfo" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 24,
                                        margin: '12px 0 0 0',
                                        padding: 0,
                                        listStyle: 'none'
                                    }}>
                                        <li style={{ fontSize: 16, color: '#222' }}>
                                            <span>
                                                <strong>
                                                    <i className="fa fa-rupee-sign" style={{ marginRight: 4, color: '#388e3c' }}></i>
                                                    {doctorDetails?.starting_price ? `Starting ₹${doctorDetails?.starting_price}` : 'Contact for Price'}
                                                </strong>
                                            </span>
                                        </li>

                                        <Feedbackcount data={data} />
                                    </ul>
                                </div>
                                <div className="dc-description" style={{ margin: '18px 0 0 0', color: '#444', fontSize: 16, lineHeight: 1.6 }}>
                                    <p style={{ margin: 0 }}>{data.subheading}</p>
                                </div>
                                <div className="dc-btnarea doctorpage-btnarea d-flex" style={{ marginTop: 24, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                                    <button
                                        type="button"
                                        className="dc-btn dc-btnactive cl-12 p-0"
                                        onClick={() => setIsFeedbackOpen(true)}
                                    >
                                        <i className="far fa-comment-alt" style={{ marginRight: 8 }}></i>
                                        <span className="cl-12">Add Feedback</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="dc-btn dc-btnactive cl-12 p-0"
                                        onClick={() => setIsBookingOpen(true)}
                                    >
                                        <i className="far fa-calendar-check" style={{ marginRight: 8 }}></i>
                                        <span className="cl-12">Book Now</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="dc-btn dc-btnactive cl-12 p-0"
                                        onClick={e => { e.preventDefault(); addToWishlist(data.id); }}
                                    >
                                        <i className="far fa-heart" style={{ marginRight: 6 }}></i>
                                        <span className="cl-12">Wishlist</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <TbesCompont toggleAdvancedSearch={toggleAdvancedSearch} showcomponents={showcomponents} data={data} doctorDetails={doctorDetails} loadtype={loadtype} />



                    </div>

                    <div className="col-12 col-md-6 col-lg-6 col-xl-3 float-left">
                        <aside id="dc-sidebar" className="dc-sidebar dc-sidebar-grid float-left mt-xl-0">

                            <div className="dc-contactinfobox dc-locationbox">
                                <div className="dc-mapbox">
                                    <MapComponent
                                        latitude={doctorDetails?.doctor_default_location?.[0]?.lat ?? data?.latitude}
                                        longitude={doctorDetails?.doctor_default_location?.[0]?.lng ?? data?.longitude}
                                        address={extractAddressForMap(doctorDetails, data)}
                                        type={loadtype} />
                                </div>
                                <ul className="dc-contactinfo">
                                    {(() => {
                                        const locationData = doctorDetails?.doctor_default_location && doctorDetails.doctor_default_location.length > 0
                                            ? doctorDetails.doctor_default_location[0]
                                            : null;

                                        const address = locationData?.full_address || locationData?.address || doctorDetails?.address || null;
                                        const latitude = locationData?.lat;
                                        const longitude = locationData?.lng;

                                        return (
                                            <div className="dc-location-container" style={{ marginBottom: '10px' }}>
                                                <GoogleMapsLink
                                                    latitude={latitude}
                                                    longitude={longitude}
                                                    address={address}
                                                    name={data.display_name}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        color: '#666',
                                                        fontSize: '14px',
                                                        textDecoration: 'none'
                                                    }}
                                                >
                                                    <i className="ti-location-pin"></i>
                                                    <span style={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '200px'
                                                    }}>
                                                        {address || 'Location not available'}
                                                    </span>
                                                    <i className="fas fa-external-link-alt" style={{ fontSize: '10px', opacity: 0.7 }}></i>
                                                </GoogleMapsLink>
                                            </div>
                                        );
                                    })()}
                                </ul>
                                <a className="dc-btn dc-btn-lg" href={`https://www.google.com/maps/place/${doctorDetails?.doctor_default_location ? doctorDetails?.doctor_default_location[0]?.lat : data.latitude},${doctorDetails?.doctor_default_location ? doctorDetails?.doctor_default_location[0]?.lng : data.longitude}`} target="_blank" rel="noreferrer">Get Directions</a>
                            </div>

                            <div id="doctreat_query_online-4" className="dc-sidebarquery dc-widget dc-onlineoptions dc-ads-wgdets">
                                <figure className="dc-onlinuserimg">
                                    <img width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/11/sidebar01.jpg" alt="Query online" />
                                    <figcaption>
                                        <span>Live</span>
                                    </figcaption>
                                </figure>
                                <div className="dc-onlineoption-content">
                                    <div className="dc-title">
                                        <h3><span>Stop Waiting In Queue</span>Ask Query Online</h3>
                                    </div>
                                    <div className="dc-btnarea">
                                        <button className="dc-btn dc-btnactive">Book Audio / Video Call</button>
                                    </div>
                                </div>
                            </div>
                            <div id="doctreat_apps-4" className="dc-sidebarapps dc-widget dc-mobileappoptions dc-ads-wgdets">
                                <figure className="dc-appimgs">
                                    <img width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/11/sidebar02.jpg" alt="App downloads" />
                                </figure>
                                <div className="dc-mobileapp-content">
                                    <div className="dc-title">
                                        <h3>
                                            <span>Care On The GO</span>	Get Mobile App</h3>
                                    </div>
                                    <div className="dc-description">
                                        <p>A dipisicing sed dotem eiusmou tempor incididunt ut labore</p>
                                    </div>
                                    <div className="dc-appemail-form">
                                        <input type="email" name="app_email" value="" className="form-control" placeholder="Email ID" required="" />
                                        <button type="submit" className="dc-get-app"><i className="fa fa-paper-plane"></i></button>
                                    </div>
                                </div>

                            </div>
                            <div id="doctreat_adds-3" className="dc-sidebaradds dc-searchresultad dc-ads-wgdets">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/08/img-02-4.jpg" alt="" />
                            </div>
                        </aside>
                    </div>

                </div>
            </div>

            {isFeedbackOpen && (
                <FeedbackPopup
                    isOpen={isFeedbackOpen}
                    onClose={() => setIsFeedbackOpen(false)}
                    doctorId={data?.id}
                />
            )}

            {isBookingOpen && (
                <BookingPopup
                    isOpen={isBookingOpen}
                    onClose={() => setIsBookingOpen(false)}
                    doctorId={data?.id}
                    doctorName={decodeHtml(formatDoctorName(data.display_name))}
                    consultationFee={doctorDetails?.starting_price || 500}
                />
            )}


        </div>

    );
};

export default Doctorpage;
